import { z } from 'zod';

export const DESCRIPTION_MAX_LENGTH = 300;
export const MAX_FILES = 2;
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const ACCEPTED_FILE_TYPES = ['image/jpeg', 'image/png', 'application/pdf'] as const;
export const ACCEPTED_FILE_EXTENSIONS = '.jpg,.jpeg,.png,.pdf';

export const descriptionFormSchema = z.object({
  description: z
    .string()
    .trim()
    .min(1, 'Descreva sua solicitação')
    .max(DESCRIPTION_MAX_LENGTH, `Limite de ${DESCRIPTION_MAX_LENGTH} caracteres`),
});

export type DescriptionFormValues = z.infer<typeof descriptionFormSchema>;

/** Valida um arquivo no momento da seleção — arquivos inválidos nunca chegam a entrar em `values.files`. */
export function getFileError(file: File): string | undefined {
  if (!ACCEPTED_FILE_TYPES.includes(file.type as (typeof ACCEPTED_FILE_TYPES)[number])) {
    return 'Formato não permitido. Use JPG, JPEG, PNG ou PDF.';
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return 'Arquivo muito grande. Envie um arquivo de até 10 MB.';
  }
  return undefined;
}
